// extracted by mini-css-extract-plugin
export var alertIcon = "_o0-0";